module.exports = __webpack_public_path__ + "static/media/Tick.d683bac8.wav";